import styled from 'styled-components';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import breakpoints from 'theme/atoms/breakpoints';
import shadows from 'theme/atoms/shadows';

export const AccordianCard = styled(Accordion)`
  background-color: white;
  border-radius: 40px;
  box-shadow: ${shadows.M};
  color: black;
  display: flex;
  flex-direction: column;
  margin: 30px 0;
  text-decoration: none;
  width: 100%;

  &::before {
    display: none;
  }

  &:last-of-type {
    border-radius: 25px;
  }

  &:first-of-type {
    border-radius: 25px;
  }

  .MuiCollapse-vertical {
    border-radius: 0 0 25px 25px;
    overflow: hidden;
  }
`;

export const AccordionOverview = styled(AccordionSummary)`
  padding: 30px;

  .MuiAccordionSummary-content {
    margin: 0;
  }

  @media (max-width: ${breakpoints.mobileM}) {
    padding: 20px;
  }
`;

export const AccordionContent = styled(AccordionDetails)`
  border-top: 2px solid #c4c4c4;
  padding: 0;
`;

export const BasicCard = styled('div')`
  background-color: white;
  border-radius: 60px;
  box-shadow: ${shadows.L};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 580px;
  padding: 90px;
  width: 100%;

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
    max-height: initial;
    max-width: initial;
  }
`;

export const BaseCard = styled('div')`
  background-color: white;
  border-radius: 40px;
  box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.03),
    0 20px 80px -15px rgba(0, 29, 37, 0.1);
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  svg {
    stroke-width: 2;
  }
`;
